import { render, staticRenderFns } from "./CardUpdate.vue?vue&type=template&id=a9648186&scoped=true"
import script from "./CardUpdate.vue?vue&type=script&lang=js"
export * from "./CardUpdate.vue?vue&type=script&lang=js"
import style0 from "./CardUpdate.vue?vue&type=style&index=0&id=a9648186&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9648186",
  null
  
)

export default component.exports